import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import UnmappedContext from "./UnmappedContext.js";
;
import { decorateName } from "./utils.js";
export var Unmapped = decorateName(observer(_ref => {
  var {
    store,
    children
  } = _ref;
  useEffect(() => {
    // console.log(`needsRefresh: ${store.needsRefresh}`, store);
    if (store.needsRefresh) {
      store.startFetch();
    }
    // console.log(store);
  }, [store.needsRefresh]);
  return /*#__PURE__*/React.createElement(UnmappedContext.Provider, {
    value: {
      store
    }
  }, children);
}), 'Unmapped');
export default Unmapped;
//# sourceMappingURL=Unmapped.js.map